// One place that knows how to read a manager's display name.
//
// League member records reach components in two shapes. LeagueContext hands
// out raw league_members rows (team_name, first_name), while useLeagueData
// maps the same records to camelCase (teamName, firstName). Both are passed
// around as "members", and which one a component receives depends on who
// renders it.
//
// That mismatch has produced the same bug twice in RecentMovesWidget: once
// reading managerName and droppedTeam, which never existed, and again reading
// only the camelCase spelling, so every entry on the League tab said "A
// manager" while the avatar beside it resolved correctly, UserAvatar having
// checked both spellings all along.
//
// Reading both is the cheap fix. Unifying the two shapes is the real one, and
// is a bigger change than any single call site should carry.
export const FALLBACK_MANAGER_NAME = "A manager";

export function memberDisplayName(member, fallback = FALLBACK_MANAGER_NAME) {
  if (!member) return fallback;

  const team = member.teamName || member.team_name;
  if (team && String(team).trim()) return String(team).trim();

  const first = member.firstName || member.first_name;
  if (first && String(first).trim()) return String(first).trim();

  return fallback;
}

// The same member by first name, for a line that is about the person rather
// than their squad: "Outbid: Greg ($50)". Falls back to the squad name, then
// to the generic one, so a manager with no first name on file still appears.
// A blocked manager's first name is already masked upstream (blocking.js).
export function memberFirstName(member, fallback = FALLBACK_MANAGER_NAME) {
  if (!member) return fallback;

  const first = member.firstName || member.first_name;
  if (first && String(first).trim()) return String(first).trim();

  return memberDisplayName(member, fallback);
}
